import { Component, OnInit, Inject, Input, HostListener, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators, AbstractControl, FormControl, Form } from '@angular/forms';
import { HttpEventType, HttpClient, HttpHeaders } from "@angular/common/http";
import { GlobalService } from '../service/global.service';
import { environment } from 'src/environments/environment';
import { ProjectInfo } from '../model/project.model';
import { ContactlistInfo } from '../model/contactlist.model';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { Pipe, PipeTransform } from '@angular/core';
import { LookupInfo } from '../model/lookup.model';
import { CompanyInfo } from '../model/company.model';
import { EmpInfo } from '../model/emp.model';
import { IssueInfo } from '../model/issue.model';
import { IssueManagementComponent, summaryInfo, summarydetailInfo } from '../issue-management/issue-management.component'; //Add from lesson learned tab
import { GanttChartControlComponent } from "../gantt-chart-control/gantt-chart-control.component";
import { ProjectRoleInfo } from '../model/projectrole.model';
import { data } from 'jquery';
import { NgModule } from '@angular/core';
import { async } from '@angular/core/testing';
import { ActivatedRoute } from '@angular/router';
import { TokenService } from '../service/token.service';

let today = new Date().toISOString()

@Component({
  selector: 'app-contact-list',
  templateUrl: './contact-list.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./contact-list.component.css']
})
export class ContactListComponent implements OnInit {
  @ViewChild(GanttChartControlComponent) ganttchart;

  @Input() ViewMode: boolean = false;


  displayloading: boolean = false;
  Msgloadding: string = '';
  public body: string;
  ProjectList: ProjectInfo[]
  ProjectStatusList: ContactlistInfo[]

  _ParamProjectCode: string

  titlemodal: string
  detailmodal: string

  txtProjectCode: string
  txtProjectName: string
  txtProjectStart: string
  txtProjectEnd: string
  ddlProjectStatus: string
  ddlProjectStatusSavedraft: string

  ProjectTotal: any
  isOnUpdate: boolean;

  element: HTMLElement;
  public hidcouchk: string;

  txtProjectComment: string;

  ddlSupportContractType: string = null;
  ddlWarrantyType: string = null;
  ddlMAType: string = null;
  txtWarrantyStartDate: string = null;
  txtWarrantyEndDate: string = null;
  txtMAStartDate: string = null;
  txtMAEndDate: string = null;
  ddlPackage: number = null;
  strValue: string = "Y";

  SupportContractTypeList: any;
  WarrantyTypeList: any;
  MATypeList: any;
  ProjectPackageList: any;

  issueListAll: IssueInfo[]
  IssuePromise: Promise<IssueInfo[]>
  summaryInfo = new summaryInfo;


  IssueSummaryTotal: any

  lblbaselinestartdate: string;
  lblbaselineenddate: string;
  lblbaselinetotaldays: number;
  lblactualstartdate: string;
  lblactualenddate: string;
  lblactualtotaldays: number;
  lbloverduedays: number;
  totalticket: number;
  RoleCode: string;

  inlineCheckboxBaselinePlan: boolean
  inlineCheckboxActualPlan: boolean
  SelectPlan: string = 'baseline,actual,';
  public TabProjectPlanIndex = 1;
  public TabOrganizationalIndex = 1;

  Stagelist: any;
  Actionlist: any;

  // Form Group
  ProjectDetailForm: FormGroup;

  // array control
  itemsSetup: FormArray;
  itemsSetting: FormArray;
  itemsGetting: FormArray;
  itemsBaseline: FormArray;
  selectType: LookupInfo[];
  selectCompanyInternal: CompanyInfo[];
  selectCompanyExternal: CompanyInfo[];
  selectEmpName: EmpInfo[];
  selectProjectRole: ProjectRoleInfo[];

  BaselineList: ProjectRoleInfo[];
  BaselineTimeList: ProjectRoleInfo[];

  ContactlistList: ContactlistInfo[];
  ContactlistLow: ContactlistInfo[];
  ContactlistTimeList: ContactlistInfo[];

  filesToUpload: File[];
  pathImg: string = '';


  /******************************* Variables ********************************/
  @Input() ProjectId: string;
  @Input() ProjectCode: string;

  baseurl: string;
  baselineFilesToUpload: File[];
  baselinePathFile: string = '';
  ProjectPromise: Promise<ProjectInfo[]>
  ProjectDocumentPromise: Promise<ContactlistInfo[]>
  ProjectDocumentList: ContactlistInfo[]
  ProjectRoleTypeList: LookupInfo[]
  ProjectsFileName: string[]
  filteredOptions: Observable<string[]>;
  isSubmitted: any;
  Filename: string;
  CurrentTabSelected: string;
  UserRole: string;
  IsShowForThisUser: boolean;
  IsShowForThisUserOther: boolean;
  IsShowForThisUserOtherManager: boolean;
  IsShowVersion: boolean;

  txtFileName = new FormControl();
  txtFileNameCreate = new FormControl();
  txtFileVersion = new FormControl();
  hidProjectId: number

  //Pagination variable
  //public currentPageNumber: number
  //public totalPages: number
  //public environment: number

  //Pagination
  indexNo: number = 0
  currentPageNumber: number = 1;
  totalTeams: number = 0;
  totalPages: number = 0;
  pageSize: number = 10;


  //empselect
  employeeselectrun: boolean = false;
  employeeselectreturnto: number;
  selectedemp: EmpInfo;
  /******************************* Variables ********************************/


  /******************************* Functions ********************************/
  //Constructor
  constructor(private httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string, private formBuilder: FormBuilder, private GlobalService: GlobalService, private activatedRoute: ActivatedRoute, private TokenService: TokenService) {
    this.baseurl = environment.base_api;
  }

  //Initial data
  async ngOnInit() {
    //this.currentPageNumber = 1;
    //this.environment = environment.PageSize;
    // console.log("UserRole === ", localStorage.getItem("EmpRoleCode"));
    this.currentPageNumber = 1;
    this.pageSize = environment.PageSize;
    this.UserRole = localStorage.getItem("EmpRoleCode");
    this.IsShowForThisUser = (this.UserRole != "CUSTOMER");
    this.IsShowForThisUserOther = (this.UserRole == "CUSTOMER");
    this.IsShowForThisUserOtherManager = (this.UserRole == "MANAGER" || this.UserRole == "PROJECTCO");
    this.IsShowVersion = false;
    this.CurrentTabSelected = 'Contact List';
    await this.LoadGroupProjectDocument();
    await this.OnLoadCountDocumentList();
    this.TabProjectPlanIndex = 1;
    this.SetSelectTabProject(1);
    this.SetSelectTabOrganizational(1);
    this.inlineCheckboxBaselinePlan = true;
    this.inlineCheckboxActualPlan = true;
    this.RoleCode = localStorage.getItem('EmpRoleCode');
    this._ParamProjectCode = this.GetParam('ProjectCode').toString();
    this._ParamProjectCode = this.activatedRoute.snapshot.params.ProjectCode;
    //this.currentPageNumber = 1;


    this.loadLookupType();
    this.loadContactlist();
    this.loadContactCompanyInternal();
    this.loadContactCompanyExternal();
    this.loadProjectRole();
    this.loadContactEmp();

    // create control
    this.ProjectDetailForm = this.formBuilder.group({
      BaselineForm: this.formBuilder.group({
        items: this.formBuilder.array([this.createItemBaselineDefault()])
      }),
      GettingForm: this.formBuilder.group({
        items: this.formBuilder.array([this.createItemGettingDefault()])
      }),
      SettingForm: this.formBuilder.group({
        items: this.formBuilder.array([this.createItemSettingDefault()])
      }),
      SetupForm: this.formBuilder.group({
        items: this.formBuilder.array([this.createItemSetupDefault()])
      })
    });
    this.itemsBaseline = this.ProjectDetailForm.get('BaselineForm').get('items') as FormArray;
    this.itemsBaseline.clear();
    this.GetBaselineToBaseline();
    this.GetBaselineToSetUp();
    this.GetContactlistToSetTing();
    this.GetContactlistToLow();
  }

  SetInitialAutoComplete() {
    this.filteredOptions = this.txtFileName.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value)),
    );
  }

  LoadProjectDocumentList(auth_token): Observable<ContactlistInfo[]> {
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let offset = (this.currentPageNumber - 1) * environment.PageSize;

      var objectjson = {};
      objectjson['ContactlistId'] = Number(this.ProjectId);
      objectjson['ContactlistCompanyName'] = $('#txtSchFileName').val();
      objectjson['FlagDelete'] = "N";
      objectjson['rowFetch'] = environment.PageSize;
      objectjson['rowOFFSet'] = offset;

      let strjson = JSON.stringify(objectjson);

      return this.httpClient
        .post<ContactlistInfo[]>(this.baseurl + "Contactlist/GetGroupContactlist",
          strjson, httpOptions)
    }
  }

  async LoadGroupProjectDocument() {
    var auth_token = await this.TokenService.RefreshToken();

    this.LoadProjectDocumentList(auth_token)
      .subscribe({
        next: data => {
          this.ProjectDocumentList = data;

          var tmpArr = [];
          $.each(data, function () {

            tmpArr.push(!!this.ContactlistCompanyName ? this.ContactlistCompanyName : ' ');
          });
          this.ProjectsFileName = tmpArr;
          this.SetInitialAutoComplete();
        },
        error: error => {

          console.error('There was an error!', error);
        }
      })
  }
  LoadProjectRoleTypeList(): Observable<LookupInfo[]> {
    var auth_token = this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let offset = (this.currentPageNumber - 1) * environment.PageSize;
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      const code = urlParams.get('ProjectCode');

      var objectjson = {};
      objectjson['ContactlistProjectCode'] = code;
      objectjson['FlagDelete'] = "N";
      objectjson['rowFetch'] = environment.PageSize;
      objectjson['rowOFFSet'] = offset;

      let strjson = JSON.stringify(objectjson);

      return this.httpClient
        .post<LookupInfo[]>(this.baseurl + "Lookup/GetLookupType",
          strjson, httpOptions)
    }
  }

  LoadGroupProjectRoleType() {
    this.LoadProjectRoleTypeList()
      .subscribe({
        next: data => {
          this.ProjectRoleTypeList = data;

          var tmpArr = [];
          $.each(data, function () {

            tmpArr.push(!!this.LookupCode ? this.LookupCode : ' ');
          });
          this.ProjectsFileName = tmpArr;
          this.SetInitialAutoComplete();
        },
        error: error => {

          console.error('There was an error!', error);
        }
      })
  }

  async LoadHistoryProjectDocument() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let offset = (this.currentPageNumber - 1) * environment.PageSize;

      var objectjson = {};
      objectjson['ContactlistId'] = Number(this.ProjectId);
      objectjson['ContactlistCompanyName'] = $('#txtSchFileName').val();
      objectjson['FlagDelete'] = "N";
      objectjson['rowFetch'] = environment.PageSize;
      objectjson['rowOFFSet'] = offset;

      let strjson = JSON.stringify(objectjson);

      this.httpClient
        .post<ContactlistInfo[]>(this.baseurl + "Contactlist/GetContactlist",
          strjson, httpOptions)
        .subscribe({
          next: data => {
            this.ProjectDocumentList = data;

            var tmpArr = [];
            $.each(data, function () {
              if (!!this.ContactlistCompanyName && tmpArr.indexOf(this.ContactlistCompanyName)) {
                tmpArr.push(!!this.ContactlistCompanyName ? this.ContactlistCompanyName : ' ');
              }
            });
            this.ProjectsFileName = tmpArr;
            this.SetInitialAutoComplete();
          },
          error: error => {

            console.error('There was an error!', error);
          }
        });
    }
  }

  async LoadCountGroupProjectDocument() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['ContactlistProjectCode'] = (this.ProjectCode);
      objectjson['FlagDelete'] = "N";

      let strjson = JSON.stringify(objectjson);

      return this.httpClient
        .post<number>(this.baseurl + "Contactlist/GetCountContactlist",
          strjson, httpOptions)
        .toPromise()
    }
  }

  async LoadCountHistoryProjectDocument() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['ContactlistId'] = Number(this.ProjectId);
      objectjson['ContactlistCompanyName'] = $('#txtSchFileName').val();
      objectjson['FlagDelete'] = "N";

      let strjson = JSON.stringify(objectjson);

      return this.httpClient
        .post<number>(this.baseurl + "Contactlist/GetCountContactlist",
          strjson, httpOptions)
        .toPromise()
    }
  }

  GetFileVersion(value: string) {
    var projectDoc = this.ProjectDocumentList.filter((x) => { return x.ContactlistCompanyName == value });
    if (!!projectDoc && projectDoc.length > 0) {
      $('#txtFileVersion').text(projectDoc[0].ContactlistId + 1);

    }
  }

  //Events function
  OnUploadTypeChange(selectedValue) {
    switch (selectedValue) {
      case "create":
        $('#FileNameUpdatePanel').addClass('d-none');
        $('#FileNameCreatePanel').removeClass('d-none');
        $('#txtFileVersion').text("-")
        break;
      case "update":
        $('#FileNameUpdatePanel').removeClass('d-none');
        $('#FileNameCreatePanel').addClass('d-none');
        break;
      default:
        $('#FileNameUpdatePanel').addClass('d-none');
        $('#FileNameCreatePanel').removeClass('d-none');
        $('#txtFileVersion').text("-")
        break;
    }
  }

  OnTextValueChange(value: string) {
    this.Filename = value;
  }

  OnSelectedTabChange(traget) {
    //Collect current tab
    this.CurrentTabSelected = traget.tab.textLabel;
    this._selectLoader(traget.tab.textLabel);
    this.loadProjectRole();
    this.loadLookupType();
    this.loadContactlist();
    this.loadContactCompanyInternal();
    this.loadContactCompanyExternal();
    this.loadContactEmp();
    this.GetContactlistToLow();
    this.loadContactlistLow();

    this.currentPageNumber = 1;
    //this.environment = environment.PageSizeSmall;
    this.LoadGroupProjectDocument();
    this.OnLoadCountDocumentList();
  }

  OnBtnUploadFileClick() {
    $('#ddlFileType').val('create');
    this.OnUploadTypeChange('create');
    this.baselineFilesToUpload = [];
    $('#txtFileVersion').text('-');
  }

  async InsertProjectDocument(pathfile) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['ContactlistId'] = Number(this.ProjectId);
      objectjson['ProjectDocumentFileName'] = this.Filename;
      objectjson['ProjectDocumentPathFile'] = pathfile;
      objectjson['FlagDelete'] = "N";
      objectjson['CreateBy'] = localStorage.getItem("EmpCode");

      let strjson = JSON.stringify(objectjson);

      this.isSubmitted = this.httpClient.post<ProjectInfo[]>(this.baseurl + "ProjectDocument/InsertProjectDocument", strjson, httpOptions)

        .subscribe(result => this.isSubmitted = result, failCb => {

          console.log("Insert fail")
        },
          () => {
            console.log("Insert = " + this.isSubmitted)

            this.LoadGroupProjectDocument();
          }
        )
    }
  }

  //For Pagination
  LoadListPagination(traget) {
    this.currentPageNumber = traget.currentPageNumber;
    this.totalPages = traget.totalPages;
  }

  OnLoadListFinished(traget = null) {

    if (traget != null) {
      // check call function from change page or onloadfrist
      this.LoadListPagination(traget);
      this.indexNo = traget.index;
    }
    this._selectLoader(this.CurrentTabSelected);
  }

  //OnLoadListFinished(traget = null) {
  //  if (traget != null) { // check call function from change page or onloadfrist
  //    this.currentPageNumber = traget.currentPageNumber;
  //    this.totalPages = traget.totalPages;
  //    this.indexNo = traget.index;
  //  }

  //  this.loadContactlist();
  //}

  OnLoadCountDocumentList() {
    //call function load count all ticket list on hand current role user
    this.LoadCountGroupProjectDocument().then(data => {
      this.ProjectTotal = data;
      if(this.ProjectTotal == 0) this.currentPageNumber = 0;
      this.totalPages = Math.ceil(this.ProjectTotal / environment.PageSize);
    });
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    this.GetFileVersion(value);
    this.Filename = value;
    return this.ProjectsFileName.filter(option => option.toLowerCase().includes(filterValue));
  }

  private _selectLoader(tabSelectedKey: string) {

    this.GetContactlistToLow();
    this.loadContactlistLow();
    this.loadLookupType();
    this.loadContactlist();
    this.loadContactCompanyInternal();
    this.loadContactCompanyExternal();
    this.loadContactEmp();

    //this.currentPageNumber = 1;
    //this.environment = environment.PageSizeSmall;
    //this.LoadGroupProjectDocument();
    //this.OnLoadCountDocumentList();
  }



  /******************************* Functions ********************************/
  btnClick_showProjectList() {
    //this.LoadProject()
  }

  chkallclick(traget) {
    var check = $(traget.currentTarget).is(":checked");

    $('[name="checkboxProjectDocument"]').prop('checked', check);

  }

  GetParam(name) {
    const results = new RegExp('[\\?&]' + name + '=([^&#]*)').exec(window.location.href);
    if (!results) {
      return 0;
    }
    return results[1] || 0;
  }

  checkUndefinedString(strInput: string) {
    if (strInput === undefined || strInput === null) {
      strInput = ''
    }
    return strInput

  }

  checkUndefinedDate(strInput: string) {
    if (strInput === undefined || strInput === null || strInput === '') {
      strInput = null
    }
    return strInput

  }

  async loadContactlist() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['ContactlistProjectCode'] = this._ParamProjectCode;
      let strjson = JSON.stringify(objectjson);

      return await this.httpClient.post<ContactlistInfo[]>(this.baseurl + "Contactlist/GetContactlist", strjson, httpOptions)
        .toPromise()
    }
  }

  async loadContactlistLow() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let offset = (this.currentPageNumber - 1) * environment.PageSize;

      var objectjson = {};
      objectjson['ContactlistProjectCode'] = this._ParamProjectCode;
      objectjson['ContactlistCompanyName'] = $('#txtSchFileName').val();
      objectjson['FlagDelete'] = "N";
      objectjson['rowFetch'] = environment.PageSize;
      objectjson['rowOFFSet'] = offset;
      let strjson = JSON.stringify(objectjson);

      await this.httpClient.post<ContactlistInfo[]>(this.baseurl + "Contactlist/GetContactlist", strjson, httpOptions)
        .subscribe({
          next: data => {
            this.ContactlistLow = data;
            this.itemsGetting = this.ProjectDetailForm.get('GettingForm').get('items') as FormArray;
            this.itemsGetting.clear();

            this.ContactlistLow.forEach((traget, indextraget) => {
              this.itemsGetting.push(this.createItemGetting(traget));
            });
            this.SetInitialAutoComplete();

          },
          error: error => {

            console.error('There was an error!', error);
          }
        })
    }
  }

  async loadLookupType() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['LookupCode'] = this._ParamProjectCode;

      let strjson = JSON.stringify(objectjson);

      await this.httpClient.post<LookupInfo[]>(this.baseurl + "Lookup/GetLookupType", strjson, httpOptions)
        .toPromise().then((data) => {
          this.selectType = data;
        });
    }
  }

  async loadProjectRole() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['ProjectRoleProjectCode'] = this._ParamProjectCode;

      let strjson = JSON.stringify(objectjson);

      await this.httpClient.post<ProjectRoleInfo[]>(this.baseurl + "ProjectRole/GetProjectRole", strjson, httpOptions)
        .toPromise().then((data) => {
          this.selectProjectRole = data;
        });
    }
  }

  async loadContactCompanyInternal() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['CompanyCode'] = this._ParamProjectCode;

      let strjson = JSON.stringify(objectjson);

      await this.httpClient.post<CompanyInfo[]>(this.baseurl + "Company/GetContactCompanyInternal", strjson, httpOptions)
        .toPromise().then((data) => {
          this.selectCompanyInternal = data;

        });
    }
  }

  async loadContactCompanyExternal() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['CompanyCode'] = this._ParamProjectCode;

      let strjson = JSON.stringify(objectjson);

      await this.httpClient.post<CompanyInfo[]>(this.baseurl + "Company/GetContactCompanyExternal", strjson, httpOptions)
        .toPromise().then((data) => {
          this.selectCompanyExternal = data;

        });
    }
  }

  async loadContactEmp() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      let strjson = JSON.stringify(objectjson);

      await this.httpClient.post<EmpInfo[]>(this.baseurl + "Employee/GetEmployeeCriteria", strjson, httpOptions)
        .toPromise().then((data) => {
          this.selectEmpName = data;
          this.selectEmpName.map(o => {
            o.emp_label =
              ` ${o.EmpCode} - ${o.EmpName_TH}
          `
            return o
          });
        });
      
    }
  }

  async loadBaseline() {

    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['ProjectRoleProjectCode'] = this._ParamProjectCode;

      let strjson = JSON.stringify(objectjson);

      return await this.httpClient.post<ProjectRoleInfo[]>(this.baseurl + "ProjectRole/GetProjectRole", strjson, httpOptions)
        .toPromise()
    }
  }

  GetBaselineToBaseline() {

    this.loadContactlist().then((data) => {
      this.ContactlistList = data;
      this.itemsBaseline = this.ProjectDetailForm.get('BaselineForms').get('items') as FormArray;
      this.itemsBaseline.clear();
      this.ContactlistList.forEach((traget, indextraget) => {
        this.itemsBaseline.push(this.createItemBaseline(traget));
      });
    });
  }

  GetContactlistToLow() {
    this.loadContactlistLow().then((data) => {
    });
  }

  GetContactlistToSetTing() {
    this.loadContactlist().then((data) => {
      this.ContactlistList = data;
      this.itemsSetting = this.ProjectDetailForm.get('SettingForm').get('items') as FormArray;
      this.itemsSetting.clear();
      this.ContactlistList.forEach((traget, indextraget) => {
        this.itemsSetting.push(this.createItemSetting(traget));
      });
    });
  }

  GetBaselineToSetUp() {
    this.loadBaseline().then((data) => {
      this.BaselineList = data;
      this.itemsSetup = this.ProjectDetailForm.get('SetupForm').get('items') as FormArray;
      this.itemsSetup.clear();
      this.BaselineList.forEach((traget, indextraget) => {
        this.itemsSetup.push(this.createItemSetup(traget));
      });
    });
  }

  async btnClick_submitInsertProjectContact() {
    if (this.ProjectDetailForm.get('SettingForm').valid) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
    
      this.loading(true, 'Saving ...');
      var flagremove = null;
      //remove old data
      await this.RemoveoldProjectContact().then((data) => {
        flagremove = data;
      });
        if (flagremove == true) {
          
          console.log('form submitted');
          const httpOptions = {
            headers: new HttpHeaders({
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${auth_token}`
            })
          };
          var listsetting = this.ProjectDetailForm.get('SettingForm').get('items') as FormArray;
          var listsettingcontrols = listsetting.controls;
          var arrayinsert = [];
          listsettingcontrols.forEach((itemcurrent) => {
            var objectjson = {};

            objectjson['ContactlistProjectCode'] = this._ParamProjectCode;
            objectjson['ContactlistId'] = !!(itemcurrent.value.ContactlistId) ? itemcurrent.value.ContactlistId : 0;
            objectjson['ContactlistTypeCode'] = itemcurrent.value.ContactlistTypeCode;
            objectjson['ContactlistCompanyCode'] = itemcurrent.value.ContactlistCompanyCode;
            objectjson['ContactlistEmpCode'] = itemcurrent.value.ContactlistEmpCode;
            objectjson['ContactlistName'] = itemcurrent.value.ContactlistName;
            objectjson['ContactlistRoleId'] = itemcurrent.value.ContactlistRoleId;
            //for (this.selectEmpName === itemcurrent.value.ContactlistEmpCode) {
            //objectjson['ContactlistNickName'] = this.selectEmpName.values("NickName")
            //  /*objectjson['ContactlistNickName'] = this.selectEmpName.get("ContactlistNickName").setValue(itemcurrent.value.ContactlistNickName);*/
            //}
            objectjson['ContactlistNickName'] = itemcurrent.value.ContactlistNickName;
            objectjson['ContactlistPhone'] = itemcurrent.value.ContactlistPhone;
            objectjson['ContactlistEmail'] = itemcurrent.value.ContactlistEmail;
            objectjson['ContactlistPosition'] = itemcurrent.value.ContactlistPosition;
            objectjson['ContactlistReportProjectStatus'] = itemcurrent.value.ContactlistReportProjectStatus;
            objectjson['ContactlistReportExecutiveStatus'] = itemcurrent.value.ContactlistReportExecutiveStatus;
            objectjson['ContactlistSupportStatus'] = itemcurrent.value.ContactlistSupportStatus;
            objectjson['ContactlistNote'] = itemcurrent.value.ContactlistNote;
            objectjson['ContactlistRoleExternal'] = itemcurrent.value.ContactlistRoleExternal;
            objectjson['ContactlistCreateBy'] = this.checkUndefinedString(localStorage.getItem("EmpCode"));
            arrayinsert.push(objectjson);
          });

          let strjson = JSON.stringify(arrayinsert);
          this.isSubmitted = this.httpClient.post<any>(this.baseurl + "Contactlist/InsertContactlist", strjson, httpOptions)

            .subscribe(result => this.isSubmitted = result, failCb => {
              console.log("Insert fail")
              this.loading(false);
              this.titlemodal = 'Saving Project Plan fail.';
              this.detailmodal = 'Your project plan was saved fail.';
              $('#ModalError').modal();
            },
              () => {
                console.log("Insert = " + this.isSubmitted)
                this.loading(false);
                this.titlemodal = 'Saving Contact List done.';
                this.detailmodal = 'Your contact list was updated successfully.';
                $('#ModalComplate').modal();
              }
            )
        }
        else {
          this.loading(false);
          this.titlemodal = 'Saving Contact List fail.';
          this.detailmodal = 'Your contact list was saved fail.';
          $('#ModalError').modal();
          console.log('remove not complate')
        }
      } else {
        this.markFormGroupTouched(this.ProjectDetailForm.get('SettingForm') as FormGroup);
      }
    }
  }

  async btnClick_submitInsertProjectPlan() {
    if (this.ProjectDetailForm.get('SetupForm').valid) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
        this.loading(true, 'Saving ...');
      //  var flagremove = null;
      //  //remove old data
      //  await this.RemoveoldProjectPlan().then((data) => {
      //    flagremove = data;
      //  });

      //if (flagremove == true) {
        if (true) {
          console.log('form submitted');
          const httpOptions = {
            headers: new HttpHeaders({
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${auth_token}`
            })
          };
          var listsetup = this.ProjectDetailForm.get('SetupForm').get('items') as FormArray;
          var listsetupcontrols = listsetup.controls;
          var arrayinsert = [];
          listsetupcontrols.forEach((itemcurrent) => {
            var objectjson = {}; 
            objectjson['ProjectRoleId'] = itemcurrent.value.ProjectRoleId;
            objectjson['ProjectRoleProjectCode'] = this._ParamProjectCode;
            objectjson['ProjectRoleName'] = itemcurrent.value.ProjectRoleName;
            objectjson['ProjectRoleTier'] = itemcurrent.value.ProjectRoleTier;
            objectjson['ProjectRoleCreateBy'] = this.checkUndefinedString(localStorage.getItem("EmpCode"));
            arrayinsert.push(objectjson);
          });

          let strjson = JSON.stringify(arrayinsert);

          this.isSubmitted = this.httpClient.post<any>(this.baseurl + "ProjectRole/InsertProjectRole", strjson, httpOptions)
            .subscribe(result => this.isSubmitted = result, failCb => {
              console.log("Insert fail")
              this.loading(false);
              this.titlemodal = 'Saving Project Role fail.';
              this.detailmodal = 'Your project role was saved fail.';
              $('#ModalError').modal();
            },
              () => {
                console.log("Insert = " + this.isSubmitted)
                this.loading(false);
                this.titlemodal = 'Saving Project Role done.';
                this.detailmodal = 'Your project role was updated successfully.';
                $('#ModalComplate').modal();
              }
            )
        }
        else {
          this.loading(false);
          this.titlemodal = 'Saving Project Role fail.';
          this.detailmodal = 'Your project role was saved fail.';
          $('#ModalError').modal();
          console.log('remove not complate')
        }
      }
      else {
        this.markFormGroupTouched(this.ProjectDetailForm.get('SetupForm') as FormGroup);
      }
    }
  }

  async btnClick_UpdateProjectPlan() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
    if (this.ProjectDetailForm.get('BaselineForm').valid) {
      console.log('form updatted');
      this.loading(true, 'Saving ...');

      console.log('form submitted');
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };
      var listbaseline = this.ProjectDetailForm.get('BaselineForm').get('items') as FormArray;
      var listbaselinecontrols = listbaseline.controls;
      var arrayinsert = [];
      listbaselinecontrols.forEach((itemcurrent) => {
        var objectjson = {};
        objectjson['ProjectRoleId'] = itemcurrent.value.ProjectRoleId;
        objectjson['ProjectRoleCreateBy'] = this.checkUndefinedString(localStorage.getItem("EmpCode"));
        arrayinsert.push(objectjson);
      });

      let strjson = JSON.stringify(arrayinsert);

      this.isSubmitted = this.httpClient.post<any>(this.baseurl + "ProjectRole/UpdateProjectRole", strjson, httpOptions)
        .subscribe(result => this.isSubmitted = result, failCb => {
          console.log("update fail")
          this.loading(false);
          this.titlemodal = 'Saving Project Role fail.';
          this.detailmodal = 'Your project role was saved fail.';
          $('#ModalError').modal();
        },
          () => {
            console.log("update = " + this.isSubmitted)
            this.loading(false);
            this.titlemodal = 'Saving Project Role done.';
            this.detailmodal = 'Your project role was updated successfully.';
            $('#ModalComplate').modal();
          }
        )
    } else {
      this.markFormGroupTouched(this.ProjectDetailForm.get('BaselineForm') as FormGroup);
    }
  }
  }

  async btnClick_UpdateProjectContact() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      if (this.ProjectDetailForm.get('SettingForm').valid) {
        console.log('form updatted');
        this.loading(true, 'Saving ...');

        console.log('form submitted');
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };
        var listbaseline = this.ProjectDetailForm.get('SettingForm').get('items') as FormArray;
        var listbaselinecontrols = listbaseline.controls;
        var arrayinsert = [];
        listbaselinecontrols.forEach((itemcurrent) => {
          var objectjson = {};
          objectjson['ContactlistId'] = itemcurrent.value.ContactlistId;
          objectjson['ContactlistCreateBy'] = this.checkUndefinedString(localStorage.getItem("EmpCode"));
          arrayinsert.push(objectjson);
        });

        let strjson = JSON.stringify(arrayinsert);

        this.isSubmitted = this.httpClient.post<any>(this.baseurl + "Contactlist/UpdateContactlist", strjson, httpOptions)
          .subscribe(result => this.isSubmitted = result, failCb => {
            console.log("update fail")
            this.loading(false);
            this.titlemodal = 'Saving Contact List fail.';
            this.detailmodal = 'Your contact list was saved fail.';
            $('#ModalError').modal();
          },
            () => {
              console.log("update = " + this.isSubmitted)
              this.loading(false);
              this.titlemodal = 'Saving Contact List done.';
              this.detailmodal = 'Your contact list was updated successfully.';
              $('#ModalComplate').modal();
            }
          )
      } else {
        this.markFormGroupTouched(this.ProjectDetailForm.get('SettingForm') as FormGroup);
      }
    }
  }

  async RemoveoldProjectPlan() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let strjson = "{\"ProjectRoleProjectCode\":\"" + this._ParamProjectCode + "\" }";

      return await this.httpClient.post<any>(this.baseurl + "ProjectRole/DeleteProjectRole", strjson, httpOptions)
        .toPromise()
    }
  }

  async RemoveoldProjectContact() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let strjson = "{\"ContactlistProjectCode\":\"" + this._ParamProjectCode + "\" }";

      return await this.httpClient.post<any>(this.baseurl + "Contactlist/DeleteContactlist", strjson, httpOptions)
        .toPromise()
    }
  }

  createAction(actionInputs) {
    const arr = actionInputs.map(action => {
      return new FormControl(action.selected || false);
    });
    return new FormArray(arr);
  }

  SetSelectTabProject(tabCount: number) {
    this.TabProjectPlanIndex = (this.TabProjectPlanIndex + 1) % tabCount;
  }

  SetSelectTabOrganizational(tabCount: number) {
    this.TabOrganizationalIndex = (this.TabOrganizationalIndex + 1) % tabCount;
  }

  OnClickSetUp() {
    this.TabProjectPlanIndex = (this.TabProjectPlanIndex + 1) % 3;
  }

  OnClickBack() {
    this.TabProjectPlanIndex = (this.TabProjectPlanIndex + 1) % 2;
  }


  OnClickSetUpOrganizational() {
    this.TabOrganizationalIndex = (this.TabOrganizationalIndex + 1) % 2;
  }

  OnClickBackOrganizational() {
    this.TabOrganizationalIndex = (this.TabOrganizationalIndex + 1) % 1;
  }

  createItemSetupDefault(): FormGroup {
    return this.formBuilder.group({
      ProjectCode: [''],
      ProjectRoleName: ['', Validators.required],
      ProjectRoleTier: ['', Validators.required],
    },
    );
  }

  createItemGettingDefault(): FormGroup {
    return this.formBuilder.group({
      ProjectCode: [''],
      ContactlistProjectName: [''],
      ContactlistId: [''],
      ContactlistTypeCode: [''],
      ContactlistCompanyCode: [''],
      ContactlistEmpCode: [''],
      ContactlistName: [''],
      ContactlistRoleId: [''],
      ContactlistTypeName: [''],
      ContactlistEmpName: [''],
      ContactlistRoleName: [''],
      ContactlistNickName: [''],
      ContactlistCompanyName: [''],
      ContactlistPhone: [''],
      ContactlistEmail: [''],
      ContactlistReportProjectStatus: [''],
      ContactlistReportExecutiveStatus: [''],
      ContactlistSupportStatus: [''],
      ContactlistPosition: [''],
      ContactlistPositionName: [''],
      ContactlistNote: [''],
      ContactlistRoleExternal: ['']
    },
    );
  }

  createItemSettingDefault(): FormGroup {
    return this.formBuilder.group({
      ProjectCode: [''],
      ContactlistProjectName: [''],
      ContactlistId: [''],
      ContactlistTypeCode: [''],
      ContactlistCompanyCode: [''],
      ContactlistEmpCode: [''],
      ContactlistName: [''],
      ContactlistRoleId: [''],
      ContactlistTypeName: [''],
      ContactlistEmpName: [''],
      ContactlistRoleName: [''],
      ContactlistNickName: [''],
      ContactlistCompanyName: [''],
      ContactlistPhone: [''],
      ContactlistEmail: [''],
      ContactlistReportProjectStatus: [''],
      ContactlistReportExecutiveStatus: [''],
      ContactlistSupportStatus: [''],
      ContactlistPosition: [''],
      ContactlistPositionName: [''],
      ContactlistNote: [''],
      ContactlistRoleExternal: ['']
    },
    );
  }

  checkdate(
    controlName: string,
    matchingControlName: string
  ) {
    return (formGroup: FormGroup) => {
      const startcontrol = formGroup.controls[controlName];
      const endcontrol = formGroup.controls[matchingControlName];

      if (endcontrol.errors && !endcontrol.errors.checkdate) {
        return;
      }

      if (Date.parse(startcontrol.value) > Date.parse(endcontrol.value)) {
        endcontrol.setErrors({ checkdate: true });
      } else {
        endcontrol.setErrors(null);
      }
    };
  }

  checkdateActual(
    controlName: string,
    matchingControlName: string
  ) {
    return (formGroup: FormGroup) => {
      const startcontrol = formGroup.controls[controlName];
      const endcontrol = formGroup.controls[matchingControlName];

      if (endcontrol.errors && !endcontrol.errors.checkdate) {
        return;
      }

      if ((startcontrol.value == '' || startcontrol.value == null) && endcontrol.value != null && endcontrol.value != "") {
        startcontrol.setErrors({ needstartdate: true });
        startcontrol.markAsTouched();
        endcontrol.markAsTouched();

      } else {
        startcontrol.setErrors(null);
      }
    };
  }


  checkdatecurrent(
    controlName: string,
  ) {
    return (formGroup: FormGroup) => {
      const startcontrol = formGroup.controls[controlName];

      if (startcontrol.errors && !startcontrol.errors.checkdatecurrent) {
        return;
      }

      if (Date.parse(new Date().toDateString()) > Date.parse(startcontrol.value)) {
        startcontrol.setErrors({ checkdatecurrent: true });
      } else {
        startcontrol.setErrors(null);
      }
    };
  }

  createItemSetup(baselineitem: ProjectRoleInfo): FormGroup {
    return this.formBuilder.group({
      ProjectCode: [''],
      ProjectRoleId: [baselineitem.ProjectRoleId],
      ProjectRoleName: [baselineitem.ProjectRoleName, Validators.required],
      ProjectRoleTier: [baselineitem.ProjectRoleTier, Validators.required]
    },
    );
  }

  createItemGetting(contactlistlow: ContactlistInfo): FormGroup {
    return this.formBuilder.group({
      ProjectCode: [''],
      ContactlistProjectName: [contactlistlow.ContactlistProjectName],
      ContactlistId: [contactlistlow.ContactlistId],
      ContactlistTypeCode: [contactlistlow.ContactlistTypeCode],
      ContactlistCompanyCode: [contactlistlow.ContactlistCompanyCode],
      ContactlistEmpCode: [contactlistlow.ContactlistEmpCode],
      ContactlistName: [contactlistlow.ContactlistName],
      ContactlistRoleId: [contactlistlow.ContactlistRoleId],
      ContactlistTypeName: [contactlistlow.ContactlistTypeName],
      ContactlistEmpName: [contactlistlow.ContactlistEmpName],
      ContactlistRoleName: [contactlistlow.ContactlistRoleName],
      ContactlistNickName: [contactlistlow.ContactlistNickName],
      ContactlistCompanyName: [contactlistlow.ContactlistCompanyName],
      ContactlistPhone: [contactlistlow.ContactlistPhone],
      ContactlistEmail: [contactlistlow.ContactlistEmail],
      ContactlistReportProjectStatus: [contactlistlow.ContactlistReportProjectStatus == 'Y' ? true : false],
      ContactlistReportExecutiveStatus: [contactlistlow.ContactlistReportExecutiveStatus == 'Y' ? true : false],
      ContactlistSupportStatus: [contactlistlow.ContactlistSupportStatus == 'Y' ? true : false],
      ContactlistPosition: [contactlistlow.ContactlistPosition],
      ContactlistPositionName: [contactlistlow.ContactlistPositionName],
      ContactlistNote: [contactlistlow.ContactlistNote],
      ContactlistRoleExternal: [contactlistlow.ContactlistRoleExternal]
    },
    );
  }


  createItemSetting(contactlistitem: ContactlistInfo): FormGroup {
    return this.formBuilder.group({
      ProjectCode: [''],
      ContactlistProjectName: [contactlistitem.ContactlistProjectName],
      ContactlistId: [contactlistitem.ContactlistId],
      ContactlistTypeCode: [contactlistitem.ContactlistTypeCode],
      ContactlistCompanyCode: [contactlistitem.ContactlistCompanyCode],
      ContactlistEmpCode: [contactlistitem.ContactlistEmpCode],
      ContactlistName: [contactlistitem.ContactlistName],
      ContactlistRoleId: [contactlistitem.ContactlistRoleId],
      ContactlistTypeName: [contactlistitem.ContactlistTypeName],
      ContactlistEmpName: [contactlistitem.ContactlistEmpName],
      ContactlistRoleName: [contactlistitem.ContactlistRoleName],
      ContactlistNickName: [contactlistitem.ContactlistNickName],
      ContactlistCompanyName: [contactlistitem.ContactlistCompanyName],
      ContactlistPhone: [contactlistitem.ContactlistPhone],
      ContactlistEmail: [contactlistitem.ContactlistEmail],
      ContactlistReportProjectStatus: [contactlistitem.ContactlistReportProjectStatus == 'Y' ? true : false],
      ContactlistReportExecutiveStatus: [contactlistitem.ContactlistReportExecutiveStatus == 'Y' ? true : false],
      ContactlistSupportStatus: [contactlistitem.ContactlistSupportStatus == 'Y' ? true : false],
      ContactlistPosition: [contactlistitem.ContactlistPosition],
      ContactlistPositionName: [contactlistitem.ContactlistPositionName],
      ContactlistNote: [contactlistitem.ContactlistNote],
      ContactlistRoleExternal: [contactlistitem.ContactlistRoleExternal]
    },
    );
  }

  createItemBaselineDefault(): FormGroup {
    return this.formBuilder.group({
      ProjectCode: [''],
      ContactlistTypeName: ['', Validators.required],
      ContactlistEmpName: ['', Validators.required],
      ContactlistRoleName: ['', Validators.required],
      ContactlistNickName: ['', Validators.required],
      ContactlistCompanyName: ['', Validators.required],
      ContactlistPhone: ['', Validators.required],
      ContactlistEmail: ['', Validators.required],
      ContactlistReportProjectStatus: ['', Validators.required],
      ContactlistReportExecutiveStatus: ['', Validators.required],
      ContactlistSupportStatus: ['', Validators.required],
      ContactlistPosition: ['', Validators.required],
      ContactlistNote: ['', Validators.required]
    },
    );
  }

  createItemBaseline(baselineitem: ContactlistInfo): FormGroup {
    return this.formBuilder.group({
      ProjectCode: [''],
      ContactlistId: [baselineitem.ContactlistId],
      ContactlistTypeName: [baselineitem.ContactlistTypeName, Validators.required],
      ContactlistEmpName: [baselineitem.ContactlistEmpName, Validators.required],
      ContactlistRoleName: [baselineitem.ContactlistRoleName, Validators.required],
      ContactlistNickName: [baselineitem.ContactlistNickName, Validators.required],
      ContactlistCompanyName: [baselineitem.ContactlistCompanyName, Validators.required],
      ContactlistPhone: [baselineitem.ContactlistPhone, Validators.required],
      ContactlistEmail: [baselineitem.ContactlistEmail, Validators.required],
      ContactlistReportProjectStatus: [baselineitem.ContactlistReportProjectStatus, Validators.required],
      ContactlistReportExecutiveStatus: [baselineitem.ContactlistReportExecutiveStatus, Validators.required],
      ContactlistSupportStatus: [baselineitem.ContactlistSupportStatus, Validators.required],
      ContactlistPosition: [baselineitem.ContactlistPosition, Validators.required],
      ContactlistNote: [baselineitem.ContactlistNote, Validators.required]
    },
      {
        // Used custom form validator 
        validator: [this.checkdateActual("BaselineActualStartDate", "BaselineActualEndDate"), this.checkdate("BaselineActualStartDate", "BaselineActualEndDate")]
      }
    );
  }

  addItem(): void {
    this.itemsSetup = this.ProjectDetailForm.get('SetupForm').get('items') as FormArray;
    this.itemsSetup.push(this.createItemSetupDefault());
  }

  addContactItem(): void {
    this.itemsSetting = this.ProjectDetailForm.get('SettingForm').get('items') as FormArray;
    this.itemsSetting.push(this.createItemSettingDefault());
  }
  

  btnClick_deleteContractlist(indexitem, auth_token): Observable<ContactlistInfo[]> {
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };
      var objectjson = {};
      objectjson['ContactlistId'] = indexitem;

      let strjsonCusInfo = JSON.stringify(objectjson);

      return this.httpClient.post<ContactlistInfo[]>(this.baseurl + "Contactlist/DeleteContactlist", strjsonCusInfo, httpOptions);
    }
  }
  async btnClick_deleteContractlistitem(indexitem) {
    var auth_token = await this.TokenService.RefreshToken();

    if (confirm("Are you sure you want to delete this Contract list ?")) {
      this.btnClick_deleteContractlist(parseInt(indexitem), auth_token).toPromise()
        .then(
          data => {
            console.log('หลังรับค่า');
            // reload contact list
            this.GetContactlistToSetTing();

            this.titlemodal = 'Delete Contact List done.';
            this.detailmodal = 'Your contact list was deleted successfully.';
            $('#ModalComplate').modal();
          }
        );
    }
  }

  removeItemContact(indexitem): void {
    this.itemsSetting = this.ProjectDetailForm.get('SettingForm').get('items') as FormArray;
    this.itemsSetting.removeAt(indexitem);
  }

  removeItem(indexitem): void {
    this.itemsSetup = this.ProjectDetailForm.get('SetupForm').get('items') as FormArray;
    this.itemsSetup.removeAt(indexitem);
  }

  getvalueselect(traget, index) {
    this.itemsBaseline = this.ProjectDetailForm.get('BaselineForm').get('items') as FormArray;

    var checked = traget.checked; // true mean cheked
    if (checked == true) {
      var indextraget = this.Actionlist.findIndex(x => x.LookupCode == traget.value);
      var Actionall = this.itemsBaseline.controls[index].value.BaselinePriorty;
      for (var i = 0; i < Actionall.length; i++) {
        if (i != indextraget) {
          var controlsgroup = this.itemsBaseline.controls[index] as FormGroup;
          var contraolarray = controlsgroup.controls.BaselinePriorty as FormArray;
          // set checkbox
          contraolarray.controls[i].setValue(false);
        }
      }
    } else {
      this.itemsBaseline.controls[index].value.selectaction = '';
    }

    var actionselect = this.itemsBaseline.controls[index].value.BaselinePriorty.findIndex(x => x == true);
    if (actionselect != -1) {
      this.itemsBaseline.controls[index].value.selectaction = this.Actionlist[actionselect].LookupCode;
    } else {
      this.itemsBaseline.controls[index].value.selectaction = '';
    }
  }

  // set end date = start date when select stage = Milestone
  BaselineStageChange(traget) {
    var current = traget.currentTarget;
    var currentselecttext = $(current).find('option:selected').text().trim();
    if (currentselecttext == 'Milestone') {
      var indexcontrol = $(current).attr('index');
      var FormArray = this.ProjectDetailForm.get('SetupForm').get('items') as FormArray;
      var controlsgroup = FormArray.controls[indexcontrol] as FormGroup;

      if (controlsgroup.controls.BaselineStartDate.value != '' && controlsgroup.controls.BaselineStartDate.value != null) {
        controlsgroup.controls.BaselineEndDate.setValue(controlsgroup.controls.BaselineStartDate.value);
      }
    }
  }

  // set end date = start date when select stage = Milestone  (On start date change)
  BaselineStartDateChange(traget) {
    var current = traget.currentTarget;
    var indexcontrol = $(current).attr('index');
    var FormArray = this.ProjectDetailForm.get('SetupForm').get('items') as FormArray;
    var controlsgroup = FormArray.controls[indexcontrol] as FormGroup;

    // if Base line Stage = Milestone
    if (controlsgroup.controls.BaselineType.value == '4') {
      if (controlsgroup.controls.BaselineStartDate.value != '' && controlsgroup.controls.BaselineStartDate.value != null) {
        controlsgroup.controls.BaselineEndDate.setValue(controlsgroup.controls.BaselineStartDate.value);
      }
    }
  }

  // set end date = start date when select stage = Milestone  (On start date change)
  BaselineActualStartDateChange(traget) {
    var current = traget.currentTarget;
    var indexcontrol = $(current).attr('index');
    var FormArray = this.ProjectDetailForm.get('BaselineForm').get('items') as FormArray;
    var controlsgroup = FormArray.controls[indexcontrol] as FormGroup;

    // if Base line Stage = Milestone
    if (controlsgroup.controls.BaselineTypeDisplay.value == 'Milestone') {
      if (controlsgroup.controls.BaselineActualStartDate.value != '' && controlsgroup.controls.BaselineActualStartDate.value != null) {
        controlsgroup.controls.BaselineActualEndDate.setValue(controlsgroup.controls.BaselineActualStartDate.value);
      }
    }
  }

  // ---------------------- End Project Plan  Zone  -------------------------------

  private markFormGroupTouched(formGroup: FormGroup) {
    (<any>Object).values(formGroup.controls).forEach(control => {
      control.markAsTouched();
      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }

  loading(flag: boolean, Msg: string = '') {
    this.displayloading = flag;
    this.Msgloadding = Msg;
  }

  async onChanges(idx, loadFromModal: boolean = false) {
    
    //this.selectEmpName = empcode;
    this.itemsSetting = this.ProjectDetailForm.get('SettingForm').get('items') as FormArray;

    let empcode = '';
    let empselectbox = this.itemsSetting.controls[idx].get('ContactlistEmpCode');

    if (loadFromModal) {
      empcode = this.selectedemp.EmpCode;
    } else {
      empcode = this.itemsSetting.controls[idx].get('ContactlistEmpCode').value;
    }

    console.log("selectEmpName xxxx = ", this.selectEmpName.find(x => { return x.EmpCode == empcode }));
    var nickname = this.selectEmpName.find(x => { return x.EmpCode == empcode }).NickName;
    var mobile = this.selectEmpName.find(x => { return x.EmpCode == empcode }).Mobile;
    var mails = this.selectEmpName.find(x => { return x.EmpCode == empcode }).Mail;
    //var positions = this.selectEmpName.find(x => { return x.EmpCode == empcode }).PositionCode;
    var positions = this.selectEmpName.find(x => { return x.EmpCode == empcode }).PositionName;
    var empName =  this.selectEmpName.find(x => { return x.EmpCode == empcode }).EmpName_TH;

    var EmpNickname = this.itemsSetting.controls[idx].get('ContactlistNickName');
    var EmpPhone = this.itemsSetting.controls[idx].get('ContactlistPhone');
    var EmpMail = this.itemsSetting.controls[idx].get('ContactlistEmail');
    var EmpPosition = this.itemsSetting.controls[idx].get('ContactlistPositionName');
    var EmpName = this.itemsSetting.controls[idx].get('ContactlistEmpName');

    EmpName.setValue(empName);
    EmpNickname.setValue(nickname)
    EmpPhone.setValue(mobile)
    EmpMail.setValue(mails)
    EmpPosition.setValue(positions)

    if (loadFromModal) {
      let code = this.selectEmpName.find(x => { return x.EmpCode == empcode }).EmpCode;

      empselectbox.setValue(code);
    } 
  }

  selectFileOnChange(ss) {

    var fileName = ss.currentTarget.files[0].name;
    this.filesToUpload = ss.currentTarget.files;
    $("#file").val(fileName);
    const reader = new FileReader();
    reader.onload = () => {
      this.pathImg = reader.result as string;
    }
    // read the image file as a data URL.
    reader.readAsDataURL(ss.currentTarget.files[0]);
    $('#previewImg').show();
  }

  btnClick_selectFile(traget) {
    var file = $(traget.currentTarget).parents().find(".file");
    file.trigger("click");
  }

  selectedEmp(event) {
    console.log("SELECTED EMP")

    this.selectedemp = event[0];
    console.log(this.selectedemp)

    // this.ProjectDetailForm.get('ContactlistEmpCode')?.setValue(this.selectedemp.EmpCode);
    // this.ProjectDetailForm.get('ContactlistEmpName')?.setValue(this.selectedemp.EmpName_TH);
    return this.formBuilder.group({
      ContactlistEmpCode: [this.selectedemp.EmpCode],
      ContactlistEmpName: [this.selectedemp.EmpName_TH],
    });
  }

  empselect(num) {
    this.employeeselectrun = true;
    this.employeeselectreturnto = num;
    this.selectedemp = null;
    $('#ModalEmpSelect').modal();
  }

  async saveEmpSelect() {

    if (this.selectedemp != null) {
      // hide modal Assign PM
      $('#ModalEmpSelect').modal('hide');
      this.employeeselectrun = false;


      this.onChanges(this.employeeselectreturnto, true)

      this.selectedemp = null;

    } else {
      alert("Please select an employee")
    }

  }
}
